const renderAddSubContractorRows = (subContractors, jobId) => {
    let html = '';

    subContractors.forEach((contractor, index) => {
        html += `
            <tr id="subContractor${contractor.id}">
                <td>${contractor.company_name }</td>
                <td>${contractor.first_name } ${contractor.last_name}</td>
                <td class="text-center">
                    <span class="trucks-available">${contractor.trucks_available_for_job}</span>
                    /<span class="trucks-total">${contractor.trucks_available}</span>
                </td>
                <td class="text-center" data-sort="${contractor.tandem_trucks ? 1 : 0}">
                    ${ contractor.tandem_trucks ? '<i class="far fa-check-circle"></i>' : ''}
                </td>
                <td>
                    <button
                            type="button"
                            class="btn btn--rnd add-contractor {% if contractor in  job.sub_contractors.all %}selected{% endif %}"
                            data-id="${contractor.id }"
                            data-job-id="${jobId}"
                            ${contractor.trucks_available_for_job < 1 ? disabled : null}
                    >
                        <span class="text">Add</span>
                        <i class="loading far fa-spinner fa-spin"></i>
                    </button>
                </td>
            </tr>
        `;
    });

    return html;
};

export default renderAddSubContractorRows
